<template>
  <div>
    <div class="d-flex align-end justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">ติดตามความก้าวหน้าแบบ S-curve</div>
        <div class="d-flex align-center">
          <Iconify
            icon="ion:document-text"
            color="var(--theme-color-one)"
            class="mr-3"
          ></Iconify>
          <div class="font-type-bold txt-head black--text">
            รายงานผลการดำเนินการ
          </div>
        </div>
      </div>

      <Button theme="7" @onClick="exportProgressExcel"> Export Excel </Button>
    </div>

    <divcard class="mb-5" v-if="!isOIC">
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="d-flex align-center">
          <div class="black--text txt-m-head mb-3">
            ขยายเวลาการกรอกผลการติดตามรายเดือน
          </div>
          <Iconify
            icon="material-symbols:edit"
            color="var(--theme-color-seven)"
            class="ml-3"
          ></Iconify>
        </div>
        <v-row class="px-6 pt-4">
          <v-col cols="12" class="py-0">
            <!--            radio select between form c, form d, form f then dropdown will changed by select radio-->
            <v-radio-group
              v-model="form.form_type"
              row
              label="ประเภทโครงการย่อย"
              @change="form.form_c_id = ''"
            >
              <v-radio
                label="Form C"
                value="c"
                color="var(--theme-color-one)"
              ></v-radio>
              <v-radio
                label="Form D"
                value="d"
                color="var(--theme-color-one)"
              ></v-radio>
              <v-radio
                label="Form F"
                value="f"
                color="var(--theme-color-one)"
              ></v-radio>
            </v-radio-group>
            <label class="mb-1 black--text">
              โครงการย่อย<span style="color: #f15a29">*</span>
            </label>
            <v-autocomplete
              v-model="form.form_c_id"
              :items="
                form.form_type === 'd'
                  ? formD
                  : form.form_type === 'f'
                  ? formF
                  : form.form_type === 'c'
                  ? formC
                  : []
              "
              item-text="name"
              item-value="id"
              outlined
              dense
              class="mt-2"
              style="border-radius: 30px"
              color="#F7941D"
              placeholder="โครงการย่อย"
              :rules="[(v) => !!v || 'กรุณาระบุโครงการย่อย']"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="px-6 pt-4">
          <v-col cols="6" class="py-0 px-3">
            <div class="mb-1 black--text">ปีพ.ศ.</div>
            <SelectBox
              theme="3"
              placeholder="ปีพ.ศ."
              hide-details
              dense
              :items="yearList"
              @onChange="form.extend_year = $event"
              :rules="[(v) => !!v || 'กรุณาระบุปีพ.ศ.']"
            ></SelectBox>
          </v-col>
          <v-col cols="6" class="py-0">
            <div class="mb-1 black--text">เดือน</div>
            <SelectBox
              theme="3"
              placeholder="เดือน"
              item-text="name"
              item-value="value"
              dense
              :items="monthList"
              @onChange="form.extend_month = $event"
              :rules="[(v) => !!v || 'กรุณาระบุเดือน']"
              class="px-2"
            ></SelectBox>
          </v-col>
        </v-row>

        <v-row class="px-6 pt-4">
          <v-col cols="6" class="py-0">
            <div class="mb-1 black--text">วันที่มีผล</div>
            <DatePicker
              :value="form.extend_date"
              :minDate="today"
              :maxDate="projectEndDate"
              placeholder="วันที่มีผล"
              @onInput="
                form.extend_date = $event;
                $forceUpdate();
              "
              :rules="[(v) => !!v || 'กรุณาระบุวันที่มีผล']"
            ></DatePicker>
          </v-col>
          <v-col cols="6" class="py-0">
            <div class="mb-1 black--text">วันที่สิ้นสุด</div>
            <DatePicker
              :value="form.expiration_date"
              :minDate="projectStartDate"
              placeholder="วันที่สิ้นสุด"
              @onInput="
                form.expiration_date = $event;
                $forceUpdate();
              "
              :rules="[(v) => !!v || 'กรุณาระบุวันที่สิ้นสุด']"
            ></DatePicker>
          </v-col>
        </v-row>
      </v-form>

      <v-layout justify-end align-center mt-6>
        <v-flex shrink mr-4>
          <v-btn
            width="100"
            height="35"
            depressed
            rounded
            color="#D9D9D9"
            @click="resetForm"
          >
            <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            width="100"
            height="35"
            dark
            rounded
            class="btn_gradient"
            @click="onSubmit"
          >
            <span class="font-14 font-w-700 font-ch">บันทึก</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </divcard>

    <div class="px-5">
      <divcard v-for="(team, i) in teams" :key="i" class="mb-3">
        <div class="black--text txt-m-head mb-3">1.{{ i + 1 }} ข้อมูลคณะ</div>
        <v-btn icon absolute top right style="z-index: 99" @click="delTeam(i)">
          <Iconify class="font-18" style="color: #b1b1b1" icon="mdi:delete" />
        </v-btn>
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ชื่อ - สกุล</div>
            <TextField
              theme="3"
              :value="team.s2_p1_name"
              @onChange="setTeamField('s2_p1_name', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ตำเเหน่ง</div>
            <AutoBox
              theme="3"
              :items="masterData.positions"
              item-text="name"
              item-value="name"
              :value="team.s2_p1_position"
              @onChange="setTeamField('s2_p1_position', i, $event)"
            ></AutoBox>
          </div>
        </div>

        <!-- Form 1 #line2 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">หน่วยงาน</div>
            <AutoBox
              theme="3"
              :items="masterData.institutes"
              item-text="name"
              item-value="name"
              :value="team.s2_p1_dep"
              @onChange="setTeamField('s2_p1_dep', i, $event)"
            ></AutoBox>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">สังกัด</div>
            <TextField
              theme="3"
              :value="team.s2_p1_org"
              @onChange="setTeamField('s2_p1_org', i, $event)"
            ></TextField>
          </div>
        </div>

        <!-- Form 1 #line3 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ที่อยู่</div>
            <TextField
              theme="3"
              :value="team.s2_p1_addr"
              @onChange="setTeamField('s2_p1_addr', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                <TextField
                  placeholder="09XXXXXXXX"
                  theme="3"
                  input-type="number"
                  :value="team.s2_p1_phone"
                  @onChange="setTeamField('s2_p1_phone', i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">E-mail</div>
                <TextField
                  theme="3"
                  :rules="emailRules"
                  :value="team.s2_p1_email"
                  @onChange="setTeamField('s2_p1_email', i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>

        <!-- Form 1 #line4 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ความเชี่ยวชาญ</div>
            <TextField
              theme="3"
              :value="team.s2_p1_expertise"
              @onChange="setTeamField('s2_p1_expertise', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">สัดส่วนการทำงาน</div>
                <TextField
                  theme="3"
                  :value="team.s2_p1_resp"
                  @onChange="setTeamField('s2_p1_resp', i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">ชั่วโมงการทำงาน</div>
                <TextField
                  theme="3"
                  :value="team.s2_p1_resp_hrs"
                  @onChange="setTeamField('s2_p1_resp_hrs', i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>
      </divcard>
    </div>

    <div class="d-flex gap-24 mb-5">
      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">โครงการหลัก</div>
        <AutoBox
          placeholder="โครงการหลัก"
          hide-details
          :items="masterData.main_project_list"
          :value="masterData.main_project_id"
          item-text="name"
          item-value="id"
          clearable
          @onChange="
            masterData.main_project_id = $event;
            getProgress();
          "
        ></AutoBox>
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">ภูมิภาค</div>
        <SelectBox
          placeholder="ภูมิภาค"
          hide-details
          style="max-width: 160px"
          :items="masterData.region_masters"
          :value="
            userInfo.user_type !== 'สป.อว.'
              ? parseInt(masterData.region_id)
              : null
          "
          item-text="name"
          item-value="id"
          clearable
          :disabled="userInfo.user_type === 'RSP'"
          @onChange="
            masterData.region_id = $event;
            getProgress();
          "
        ></SelectBox>

        <!-- <SelectBox
            placeholder="ภูมิภาค"
            hide-details
            style="max-width: 160px"
            :items="masterData.region_masters"
            :value="parseInt(masterData.region_id)"
            item-text="name"
            item-value="id"
            clearable
            :disabled="userInfo.user_type === 'RSP'"
            @onChange="masterData.region_id = $event; getProgress()"
        ></SelectBox> -->
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">แผนงาน</div>
        <AutoBox
          placeholder="แผนงาน"
          hide-details
          :items="masterData.plan_masters"
          :value="masterData.plan_master_id"
          item-text="plan_name_th"
          item-value="id"
          clearable
          @onChange="
            masterData.plan_master_id = $event;
            getProgress();
          "
        ></AutoBox>
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">ปี งปม.</div>
        <SelectBox
          placeholder="ปี งปม."
          hide-details
          :items="yearList"
          :value="masterData.fiscal_year"
          item-text="plan_name_th"
          item-value="id"
          style="max-width: 160px"
          @onChange="
            masterData.fiscal_year = $event;
            getProgress();
          "
        ></SelectBox>
      </div>
    </div>
    <divcard class="d-flex justify-space-between mb-2" style="gap: 12px">
      <div
        class="d-flex flex-column"
        style="min-width: 10%; max-width: 10%; gap: 10px"
      >
        <div>แผนงาน</div>
        <div>ปี งปม.</div>
      </div>

      <div
        class="d-flex flex-column"
        style="min-width: 70%; max-width: 70%; gap: 10px"
      >
        <div>{{ selectedPlanLabel }}</div>
        <div>{{ masterData.fiscal_year }}</div>
      </div>

      <Button @onClick="ToScurve()" style="min-width: 10%; max-width: 10%">
        {{ isScurve ? "กลับหน้าเดิม" : "S-curve" }}
      </Button>
    </divcard>

    <!--    <divcard class="d-flex flex-column gap-8 mb-5">-->
    <!--      <div class="d-flex gap-8">-->
    <!--        <div class="black&#45;&#45;text font-type-bold" style="min-width: 140px; max-width: 140px">แผนงาน</div>-->
    <!--        <div>-->
    <!--          {{ masterData.plan_name }}-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="d-flex gap-8">-->
    <!--        <div class="black&#45;&#45;text font-type-bold" style="min-width: 140px; max-width: 140px">ปี งปม.</div>-->
    <!--        <div>-->
    <!--          {{ masterData.fiscal_year }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </divcard>-->

    <div class="d-flex justify-end my-8">
          <v-btn
            width="100"
            height="35"
            dark
            rounded
            class="btn_gradient mr-5"
            @click="expandAll"
          >
            <span class="font-14 font-w-500 font-ch">Expand All</span>
          </v-btn>
          <v-btn
            width="100"
            height="35"
            dark
            rounded
            class="btn_gradient"
            @click="collapseAll"
          >
            <span class="font-14 font-w-500 font-ch">Collapse All</span>
          </v-btn>
        </div>

    <divcard
      v-for="(region, i) in regions"
      :key="i"
      class="d-flex flex-column gap-8 mb-5"
    >
      <div
        class="d-flex justify-space-between align-center"
        style="min-height: 38px"
      >
        <div class="black--text font-type-bold">
          {{ region.name }}
        </div>

        <!-- expand & collapse icon -->
        <v-btn
          icon
          :class="{ rotate180: regionExpanded[i] }"
          @click="toggleRegion(i)"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="#D3D3D3"
          ></Iconify>
        </v-btn>

      </div>
      <div
        class="d-flex justify-end align-center"
        style="min-height: 38px"
        v-if="regionExpanded[i] && isScurve"
      >

        <SelectBox
          v-show="isScurve"
          placeholder="โปรดระบุ"
          hide-details
          :items="seriesNames"
          :value="selectedFilter"
          class="custom-selectbox-chart"
          @onChange="
            selectedFilter = $event;
            applyFilter();
          "
        ></SelectBox>
      </div>
      <div v-if="isScurve" class="py-5" v-show="regionExpanded[i]">
        <div class="chart-container">
          <highcharts :options="chartOptionByRegion(region.name)"></highcharts>

          <div class="custom-legend">
            <span
              v-for="(item, index) in legendSeries"
              :key="index"
              :style="{ background: item.color, margin: '0 10px' }"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="py-5 overflow-x-auto mx-n6 px-6 scroll" v-show="regionExpanded[i]">
        <div class="d-flex justify-space-between align-center gap-8 px-3 mb-3">
          <div class="flex" style="min-width: 30px; max-width: 30px"></div>
          <div class="flex" style="min-width: 120px; max-width: 120px">
            โครงการ
          </div>
          <div
            class="flex text-center"
            style="min-width: 61px; max-width: 61px"
          >
            WF
          </div>
          <div
            v-for="(m, ind) in region.yearMonthList"
            :key="ind"
            class="flex"
            style="min-width: 43px; max-width: 43px"
          >
            <div class="text-center">{{ m.month_th }}</div>
            <div class="text-center">{{ m.year_th }}</div>
          </div>
          <div class="flex" style="min-width: 43px; max-width: 43px">แผนผล</div>
          <div
            class="flex text-center"
            style="min-width: 43px; max-width: 43px"
          >
            %
          </div>
          <div
            class="flex text-center"
            style="min-width: 120px; max-width: 120px"
          >
            ผู้รับผิดชอบ
          </div>
          <div
            class="flex text-center"
            style="min-width: 120px; max-width: 120px"
          >
            คำชี้แจง
          </div>
        </div>
        <!--   PLAN ITEMS   -->
        <div
          v-if="region.form_c_list && region.form_c_list.length > 0"
          class="d-flex flex-column gap-12"
        >
          <div
            v-for="(item, c_i) in region.form_c_list"
            :key="c_i"
            class="plan-card d-flex justify-space-between gap-8"
          >
            <div class="flex" style="min-width: 30px; max-width: 30px"></div>
            <div
              class="flex two-line"
              style="min-width: 120px; max-width: 120px; max-height: 45px"
            >
              {{
                item?.project_section_general_info?.project_name_th ??
                item?.project_section_general_info?.lab_name ??
                item?.form_a?.main_project.name
              }}
            </div>
            <div
              class="flex d-flex justify-space-between"
              style="min-width: 61px; max-width: 61px; height: 54px"
            >
              <v-divider vertical></v-divider>
              <div
                class="tiny-field tf-active"
                style="min-width: 40px; max-width: 40px; height: 100%"
              >
                {{ formatNumber(item.wf, 2) }}
              </div>
              <v-divider vertical></v-divider>
            </div>
            <div
              v-for="(m, m_i) in item.project_section_plan_p1_budget"
              :key="m_i"
              class="flex d-flex flex-column gap-8"
              style="min-width: 43px; max-width: 43px"
            >
              <div class="tiny-field">
                {{ m.month_value ? formatNumber(m.month_value, 2) : "-" }}
              </div>
              <div class="tiny-field">
                {{
                  m.actual_month_value
                    ? formatNumber(m.actual_month_value, 2)
                    : "-"
                }}
              </div>
            </div>

            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 43px; max-width: 43px"
            >
              <div class="tiny-field">
                {{ formatNumber(item.plan, 2) }}
              </div>
              <div class="tiny-field">
                {{ formatNumber(item.result, 2) }}
              </div>
            </div>

            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 43px; max-width: 43px"
            >
              <div class="tiny-field">
                {{ formatNumber(item.percent, 2) }}
              </div>
              <div class="tiny-field">
                {{
                  formatNumber(parseFloat((item.result * 100) / item.plan), 2)
                }}
              </div>
            </div>

            <!-- Section 1: ผู้รับผิดชอบ -->
            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 120px; max-width: 120px"
            >
              <div
                :class="
                  getResponsibleStatus(item, 'plan')
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                @click="openResponsibleModal(item, 'plan')"
              >
                <div v-if="getResponsibleStatus(item, 'plan')">
                  <v-icon size="10px" color="white">mdi-plus</v-icon>
                  เพิ่มผู้รับผิดชอบ
                </div>
                <div v-else class="text-theme-1 text-underline cursor-pointer">
                  {{ getResponsibleValue(item, "plan") }}
                </div>
              </div>
              <div
                :class="
                  getResponsibleStatus(item, 'actual')
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                @click="openResponsibleModal(item, 'actual')"
              >
                <div v-if="getResponsibleStatus(item, 'actual')">
                  <v-icon size="10px" color="white">mdi-plus</v-icon>
                  เพิ่มผู้รับผิดชอบ
                </div>
                <div v-else class="text-theme-1 text-underline cursor-pointer">
                  {{ getResponsibleValue(item, "actual") }}
                </div>
              </div>
            </div>

            <!-- Section 2: คำชี้แจง -->
            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 120px; max-width: 120px"
            >
              <div
                :class="
                  getExplanationStatus(item, 'plan')
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                @click="openExplanationModal(item, 'plan')"
              >
                <div v-if="getExplanationStatus(item, 'plan')">
                  <v-icon size="10px" color="white">mdi-plus</v-icon>
                  เพิ่มคำชี้แจง
                </div>
                <div v-else class="text-theme-1 cursor-pointer">
                  รายละเอียด
                </div>
              </div>
              <div
                :class="
                  getExplanationStatus(item, 'actual')
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                @click="openExplanationModal(item, 'actual')"
              >
                <div v-if="getExplanationStatus(item, 'actual')">
                  <v-icon size="10px" color="white">mdi-plus</v-icon>
                  เพิ่มคำชี้แจง
                </div>
                <div v-else class="text-theme-1 cursor-pointer">
                  รายละเอียด
                </div>
              </div>
            </div>
          </div>

          <!--   SUMMARY   -->
          <div class="plan-card">
            <div class="d-flex justify-space-between gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                แผนงานถ่วงน้ำหนัก
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div
                  class="tiny-field"
                  :class="{
                    'theme-color-four tf-error':
                      totalWF(region.form_c_list) !== '1.00',
                  }"
                  style="min-width: 40px; max-width: 40px"
                >
                  {{ totalWF(region.form_c_list) }}
                </div>
                <v-divider vertical></v-divider>
              </div>

              <div
                v-for="(m, ym_i) in region.yearMonthList"
                :key="ym_i"
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ weightPlan(region.form_c_list, ym_i) }}
              </div>

              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ weightActivePlan(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ weightActivePlanPercent(region.form_c_list) }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex justify-space-between gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                ผลการดำเนินงาน
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px"></div>
                <v-divider vertical></v-divider>
              </div>
              <div
                v-for="(m, ym_ind) in region.yearMonthList"
                :key="ym_ind"
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ resultPlan(region.form_c_list, ym_ind) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ weightActiveResult(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{
                  formatNumber(
                    parseFloat(
                      (weightActiveResult(region.form_c_list) * 100) /
                        weightActivePlan(region.form_c_list)
                    ),
                    2
                  )
                }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex justify-space-between gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                แผนการใช้จ่าย
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px"></div>
                <v-divider vertical></v-divider>
              </div>
              <div
                v-for="(m, ym_index) in region.yearMonthList"
                :key="ym_index"
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetPlan(region.form_c_list, ym_index) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetPlanActive(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetPlanActivePercent(region.form_c_list) }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex justify-space-between gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                การใช้จ่ายจริง
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px"></div>
                <v-divider vertical></v-divider>
              </div>
              <div
                v-for="(m, ym_index) in region.yearMonthList"
                :key="ym_index"
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetUse(region.form_c_list, ym_index) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetUseActive(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{
                  formatNumber(
                    parseFloat(
                      (budgetUseActive(region.form_c_list) * 100) /
                        budgetPlanActive(region.form_c_list)
                    ),
                    2
                  )
                }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>
          </div>
        </div>

        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
      </div>
    </divcard>

    <!-- Progress Followed Modal -->
    <v-dialog v-model="modalData.show" max-width="600">
      <v-card class="pa-6">
        <!-- Modal Title -->
        <div class="font-24 font-w-700 font-ch text-left mb-6">
          {{ getModalTitle() }}
        </div>
        <div v-if="showSubtitle()" class="font-16 font-w-500 font-ch text-left mb-6">
          {{ getModalSubtitle() }}
        </div>

        <!-- Modal Content Form -->
        <v-form ref="modalForm" v-model="modalValid" lazy-validation>
          <!-- Responsible Section - TextField for both assign and value -->
          <div v-if="modalData.section === 'responsible'">
            <div v-if="modalData.type === 'assign'">
              <TextField
                :value="modalInputValue"
                @onChange="modalInputValue = $event"
                theme="3"
                placeholder="กรุณาระบุชื่อผู้รับผิดชอบ"
                :rules="[(v) => !!v || 'กรุณาระบุผู้รับผิดชอบ']"
                required
              ></TextField>
            </div>
            <div v-else>
              <TextField
                :value="modalInputValue"
                @onChange="modalInputValue = $event"
                theme="3"
                placeholder="กรุณาระบุจำนวนชั่วโมง"
                input-type="number"
                :rules="[
                  (v) => !!v || 'กรุณาระบุจำนวนชั่วโมง',
                  (v) => !isNaN(v) && Number(v) > 0 || 'กรุณาระบุตัวเลขที่มากกว่า 0',
                ]"
                required
              ></TextField>
            </div>
          </div>

          <!-- Explanation Section - Textarea -->
          <div v-else-if="modalData.section === 'explanation'">
            <v-textarea
              v-model="modalInputValue"
              outlined
              dense
              rows="4"
              color="#F7941D"
              style="border-radius: 20px"
              :placeholder="
                modalData.type === 'add' ? 'กรุณาระบุคำชี้แจง' : 'แก้ไขคำชี้แจง'
              "
              :rules="[(v) => !!v || 'กรุณาระบุคำชี้แจง']"
              required
            ></v-textarea>
          </div>
        </v-form>

        <!-- Modal Actions -->
        <div class="d-flex justify-end mt-8">
          <v-btn
            width="100"
            height="35"
            depressed
            rounded
            color="#D9D9D9"
            class="mr-5"
            @click="closeModal()"
          >
            <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
          </v-btn>
          <v-btn
            width="100"
            height="35"
            dark
            rounded
            class="btn_gradient"
            @click="saveModal()"
          >
            <span class="font-14 font-w-700 font-ch">บันทึก</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SelectBox from "../../components/input/SelectBox";
import { mapState } from "vuex";
import AutoBox from "@/components/input/AutoBox";
import Button from "@/components/input/Button";
import { formatNumber } from "@/plugins/global-funcs";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import DatePicker from "../../components/input/DatePicker";
import { Chart } from "highcharts-vue";
import * as XLSX from "xlsx";

export default {
  name: "ProgressFollowed",
  components: {
    TextField,
    SelectBox,
    AutoBox,
    Button,
    DatePicker,
    highcharts: Chart,
  },
  data() {
    return {
      menu_extend_date: false,
      menu_expiration_date: false,
      today: null,
      form: {
        form_c_id: "",
        extend_year: "",
        extend_month: "",
        extend_date: "",
        expiration_date: "",
        form_type: "",
      },
      // Progress Followed Modal Data
      modalData: {
        show: false,
        type: "", // 'add' | 'edit' | 'assign' | 'value'
        section: "", // 'responsible' | 'explanation'
        dataType: "", // 'plan' | 'actual'
        item: null,
        value: "",
      },
      // Mock data for responsible and explanation values
      progressData: {
        responsible: {},
        explanation: {},
      },
      // Modal form data
      modalValid: true,
      modalInputValue: "",
      // Team management
      teams: [],
      emailRules: [
        (v) => !!v || "กรุณาระบุอีเมล",
        (v) => /.+@.+\..+/.test(v) || "รูปแบบอีเมลไม่ถูกต้อง",
      ],
      formatNumber,
      masterData: {},
      regions: [],
      yearBudgetList: [],
      yearList: [],
      monthList: [
        {
          value: "1",
          name: "มกราคม",
        },
        {
          value: "2",
          name: "กุมภาพันธ์",
        },
        {
          value: "3",
          name: "มีนาคม",
        },
        {
          value: "4",
          name: "เมษายน",
        },
        {
          value: "5",
          name: "พฤษภาคม",
        },
        {
          value: "6",
          name: "มิถุนายน",
        },
        {
          value: "7",
          name: "กรกฎาคม",
        },
        {
          value: "8",
          name: "สิงหาคม",
        },
        {
          value: "9",
          name: "กันยายน",
        },
        {
          value: "10",
          name: "ตุลาคม",
        },
        {
          value: "11",
          name: "พฤศจิกายน",
        },
        {
          value: "12",
          name: "ธันวาคม",
        },
      ],
      formC: [],
      formD: [],
      formF: [],
      chartData: [
        {
          region: "",
          chartOptions: {},
        },
      ],
      isScurve: false,
      selectedFilter: "all",
      regionExpanded: [],
      masterSeries: [
        { name: "แผนการดำเนินงาน", data: [], color: "#1E49A9" },
        { name: "ผลการดำเนินงาน", data: [], color: "#FD0C0C" },
        { name: "แผนการใช้จ่ายเงิน", data: [], color: "#14AE5C" },
        { name: "การใช้จ่ายจริง", data: [], color: "#1A95BC" },
      ],
      displaySeries: [],
      filterOptions: [
        { value: "all", name: "ทั้งหมด" },
        { value: "แผนการดำเนินงาน", name: "แผนการดำเนินงาน" },
        { value: "ผลการดำเนินงาน", name: "ผลการดำเนินงาน" },
        { value: "แผนการใช้จ่ายเงิน", name: "แผนการใช้จ่ายเงิน" },
        { value: "การใช้จ่ายจริง", name: "การใช้จ่ายจริง" },
      ],
      chartOptions: {
        chart: {
          type: "line",
          backgroundColor: "#fff",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
          gridLineWidth: 0,
          lineWidth: 1,
          startOnTick: true,
          endOnTick: true,
          tickmarkPlacement: "on",
        },
        yAxis: {
          title: { text: "เปอร์เซ็นต์ (%)" },
          max: 100,
          gridLineWidth: 0,
          lineWidth: 1,
        },
        legend: { enabled: false },
        plotOptions: {
          series: {
            pointPlacement: "on",
            marker: {
              enabled: false,
            },
          },
        },
        series: [],
      },
    };
  },
  created() {
    this.today = new Date().toISOString().split("T")[0];
    this.generateYearList();
    this.getProgress();
  },
  computed: {
    ...mapState({
      isUSP: (state) => state.Auth.User.user_type === "USP",
      isRSP: (state) => state.Auth.User.user_type === "RSP",
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
      userInfo: (state) => state.Auth.User,
    }),

    projectStartDate() {
      return this.extend_date ? this.extend_date.split(" ")[0] : this.today;
    },
    projectEndDate() {
      return this.expiration_date
        ? this.expiration_date.split(" ")[0]
        : undefined;
    },
    seriesNames() {
      return this.filterOptions.map((option) => ({
        value: option.value,
        text: option.name,
      }));
    },
    legendSeries() {
      return this.displaySeries;
    },
    selectedPlanLabel() {
      const masterData = this.masterData || {};
      const plans = Array.isArray(masterData.plan_masters)
        ? masterData.plan_masters
        : [];
      const planId = masterData.plan_master_id;
      if (!plans.length || !planId) {
        return "-";
      }
      const numericId = Number(planId);
      const plan =
        plans.find((item) => Number(item.id) === numericId) ||
        plans.find((item) => item.id === planId);
      if (!plan) {
        return "-";
      }
      return plan.plan_name_en
        ? `${plan.plan_name_th} (${plan.plan_name_en})`
        : plan.plan_name_th || "-";
    },
    selectedMainProjectName() {
      const masterData = this.masterData || {};
      const projects = Array.isArray(masterData.main_project_list)
        ? masterData.main_project_list
        : [];
      const projectId = masterData.main_project_id;
      if (!projectId) {
        return projects.length ? "ทั้งหมด" : "-";
      }
      const numericId = Number(projectId);
      const project =
        projects.find((item) => Number(item.id) === numericId) ||
        projects.find((item) => item.id === projectId);
      return project?.name || "-";
    },
    selectedRegionName() {
      const masterData = this.masterData || {};
      const regions = Array.isArray(masterData.region_masters)
        ? masterData.region_masters
        : [];
      const regionId = masterData.region_id;
      if (!regionId) {
        return regions.length ? "ทั้งหมด" : "-";
      }
      const numericId = Number(regionId);
      const region =
        regions.find((item) => Number(item.id) === numericId) ||
        regions.find((item) => item.id === regionId);
      return region?.name || "-";
    },
  },
  methods: {
    exportProgressExcel() {
      if (!this.regions || !this.regions.length) {
        this.$store.commit("General/setModal", {
          title: "แจ้งเตือน",
          theme: "warning",
          text: "ไม่พบข้อมูลสำหรับส่งออก",
          showCancel: false,
        });
        return;
      }

      if (!this.chartData || !this.chartData.length) {
        this.generateChartData();
      }

      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.aoa_to_sheet([
        ["แผนงาน", this.selectedPlanLabel || "-"],
        ["โครงการหลัก", this.selectedMainProjectName || "-"],
        ["ปี งปม.", this.masterData?.fiscal_year || "-"],
        ["ภูมิภาค", this.selectedRegionName || "-"],
      ]);
      XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

      const usedSheetNames = new Set(["Summary"]);

      this.regions.forEach((region, index) => {
        const headerRow = this.buildRegionHeader(region);
        const regionRows = this.buildRegionRows(region, headerRow.length);
        const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...regionRows]);
        const sheetName = this.generateSheetName(
          region?.name ? `Data - ${region.name}` : "",
          index,
          usedSheetNames,
          "Data"
        );
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const chartSheetData = this.buildChartSheet(region);
        if (chartSheetData.length > 1) {
          const chartSheet = XLSX.utils.aoa_to_sheet(chartSheetData);
          const chartSheetName = this.generateSheetName(
            region?.name ? `Chart - ${region.name}` : "",
            index + this.regions.length,
            usedSheetNames,
            "Chart"
          );
          XLSX.utils.book_append_sheet(workbook, chartSheet, chartSheetName);
        }
      });

      const fiscalYear = this.masterData?.fiscal_year || "export";
      const fileName = `progress-followed-${fiscalYear}-${format(
        new Date(),
        "yyyyMMdd"
      )}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },
    buildRegionHeader(region) {
      const header = ["โครงการ", "WF"];
      (region?.yearMonthList || []).forEach((ym) => {
        const label = `${ym.month_th} ${ym.year_th}`;
        header.push(label);
      });
      header.push("แผนผล (เดือนปัจจุบัน)");
      header.push("ผลการดำเนินงาน (เดือนปัจจุบัน)");
      header.push("% แผนสะสม");
      header.push("% ผลสะสม");
      header.push("ผู้รับผิดชอบ (แผน)");
      header.push("ค่างาน (แผน)");
      header.push("คำชี้แจง (แผน)");
      header.push("ผู้รับผิดชอบ (ผล)");
      header.push("ค่างาน (ผล)");
      header.push("คำชี้แจง (ผล)");
      return header;
    },
    buildRegionRows(region, columnCount) {
      const rows = [];
      const monthCount = region?.yearMonthList?.length || 0;
      (region?.form_c_list || []).forEach((item) => {
        const row = [this.getProjectName(item), this.formatExcelNumber(item?.wf)];
        for (let idx = 0; idx < monthCount; idx++) {
          const budget = item?.project_section_plan_p1_budget?.[idx] || {};
          row.push(
            this.formatMonthCell(budget?.month_value, budget?.actual_month_value)
          );
        }
        row.push(this.formatExcelNumber(item?.plan));
        row.push(this.formatExcelNumber(item?.result));
        row.push(this.formatExcelNumber(item?.percent));
        row.push(this.calculateActualPercent(item));
        row.push(item?.progress_month_taker || "");
        row.push(this.formatExcelNumber(item?.progress_month_taker_hours));
        row.push(item?.progress_month_remark || "");
        row.push(item?.progress_month_taker_2 || "");
        row.push(this.formatExcelNumber(item?.progress_month_taker_hours_2));
        row.push(item?.progress_month_remark_2 || "");
        rows.push(row);
      });

      if (!rows.length) {
        const placeholder = Array(columnCount).fill("");
        placeholder[0] = "ไม่มีข้อมูล";
        rows.push(placeholder);
      }

      const summaryRows = this.buildSummaryRows(region, columnCount);
      return summaryRows.length ? [...rows, Array(columnCount).fill(""), ...summaryRows] : rows;
    },
    buildSummaryRows(region, columnCount) {
      const plans = region?.form_c_list || [];
      if (!plans.length) {
        return [];
      }
      const monthCount = region?.yearMonthList?.length || 0;
      const rows = [];
      const activePlan = this.weightActivePlan(plans);
      const activeResult = this.weightActiveResult(plans);
      const budgetPlanActive = this.budgetPlanActive(plans);
      const budgetUseActive = this.budgetUseActive(plans);

      rows.push(
        this.createSummaryRow({
          labelPrefix: "แผนงานถ่วงน้ำหนัก",
          columnCount,
          monthCount,
          wfValue: this.totalWF(plans),
          monthPlanGetter: (index) => this.weightPlan(plans, index),
          planValue: activePlan,
          percentPlanValue: this.weightActivePlanPercent(plans),
        })
      );
      rows.push(
        this.createSummaryRow({
          labelPrefix: "ผลการดำเนินงาน",
          columnCount,
          monthCount,
          monthActualGetter: (index) => this.resultPlan(plans, index),
          resultValue: activeResult,
          percentResultValue: this.safePercent(activeResult, activePlan),
        })
      );
      rows.push(
        this.createSummaryRow({
          labelPrefix: "แผนการใช้จ่าย",
          columnCount,
          monthCount,
          monthPlanGetter: (index) => this.budgetPlan(plans, index),
          planValue: budgetPlanActive,
          percentPlanValue: this.budgetPlanActivePercent(plans),
        })
      );
      rows.push(
        this.createSummaryRow({
          labelPrefix: "การใช้จ่ายจริง",
          columnCount,
          monthCount,
          monthActualGetter: (index) => this.budgetUse(plans, index),
          resultValue: budgetUseActive,
          percentResultValue: this.safePercent(
            budgetUseActive,
            budgetPlanActive
          ),
        })
      );
      return rows;
    },
    createSummaryRow({
      labelPrefix,
      columnCount,
      monthCount,
      wfValue,
      monthPlanGetter,
      monthActualGetter,
      planValue,
      resultValue,
      percentPlanValue,
      percentResultValue,
    }) {
      const row = Array(columnCount).fill("");
      const {
        monthStartIndex,
        planColIndex,
        resultColIndex,
        percentPlanColIndex,
        percentResultColIndex,
      } = this.getExportColumnIndexes(columnCount, monthCount);
      row[0] = `${labelPrefix} (รวม)`;
      if (wfValue !== undefined && wfValue !== null && wfValue !== "") {
        row[1] = this.formatExcelNumber(wfValue);
      }
      for (let idx = 0; idx < monthCount; idx++) {
        const planVal = monthPlanGetter ? monthPlanGetter(idx) : "";
        const actualVal = monthActualGetter ? monthActualGetter(idx) : "";
        row[monthStartIndex + idx] = this.formatMonthCell(planVal, actualVal);
      }
      if (planValue !== undefined && planValue !== null && planValue !== "") {
        row[planColIndex] = this.formatExcelNumber(planValue);
      }
      if (
        resultValue !== undefined &&
        resultValue !== null &&
        resultValue !== ""
      ) {
        row[resultColIndex] = this.formatExcelNumber(resultValue);
      }
      if (
        percentPlanValue !== undefined &&
        percentPlanValue !== null &&
        percentPlanValue !== ""
      ) {
        row[percentPlanColIndex] = this.formatExcelNumber(percentPlanValue);
      }
      if (
        percentResultValue !== undefined &&
        percentResultValue !== null &&
        percentResultValue !== ""
      ) {
        row[percentResultColIndex] = this.formatExcelNumber(percentResultValue);
      }
      return row;
    },
    getExportColumnIndexes(columnCount, monthCount) {
      const monthStartIndex = 2;
      const trailingColumns = 10;
      if (!monthCount || monthCount < 0) {
        monthCount = columnCount - monthStartIndex - trailingColumns;
      }
      const planColIndex = monthStartIndex + monthCount;
      return {
        monthStartIndex,
        planColIndex,
        resultColIndex: planColIndex + 1,
        percentPlanColIndex: planColIndex + 2,
        percentResultColIndex: planColIndex + 3,
      };
    },
    buildChartSheet(region) {
      const chartRegion = this.getChartRegionData(region?.name);
      if (!chartRegion) {
        return [];
      }
      const seriesList = chartRegion.allSeries || [];
      if (!seriesList.length) {
        return [];
      }
      const header = [
        "เดือน",
        ...seriesList.map((series) => series.name),
      ];
      const rows = (chartRegion.categories || []).map((category, index) => {
        const row = [category];
        seriesList.forEach((series) => {
          const value = Array.isArray(series.data) ? series.data[index] : "";
          row.push(
            value === null || value === undefined
              ? ""
              : this.formatExcelNumber(value)
          );
        });
        return row;
      });
      return [header, ...rows];
    },
    getChartRegionData(regionName) {
      if (!regionName || !this.chartData || !this.chartData.length) {
        return null;
      }
      return (
        this.chartData.find((data) => data.region === regionName) || null
      );
    },
    getProjectName(item) {
      return (
        item?.project_section_general_info?.project_name_th ||
        item?.project_section_general_info?.lab_name ||
        item?.form_a?.main_project?.name ||
        "-"
      );
    },
    formatExcelNumber(value, decimals = 2) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === "-"
      ) {
        return "";
      }
      const numeric = Number(value);
      if (isNaN(numeric)) {
        return value;
      }
      return Number(numeric.toFixed(decimals));
    },
    formatMonthCell(planValue, actualValue) {
      const plan = this.formatExcelNumber(planValue);
      const actual = this.formatExcelNumber(actualValue);
      const parts = [];
      if (plan !== "") {
        parts.push(`${plan}`);
      }
      if (actual !== "") {
        parts.push(`${actual}`);
      }
      return parts.join("\n");
    },
    calculateActualPercent(item) {
      return this.formatExcelNumber(
        this.safePercent(item?.result, item?.plan)
      );
    },
    generateSheetName(name, index, usedNames, fallbackPrefix = "Region") {
      const fallback = `${fallbackPrefix} ${index + 1}`;
      let baseName = (name || fallback)
        .toString()
        .replace(/[\\/?*\[\]:]/g, " ")
        .trim();
      if (!baseName) {
        baseName = fallback;
      }
      baseName = baseName.substring(0, 31);
      let candidate = baseName;
      let counter = 1;
      while (usedNames.has(candidate)) {
        const suffix = ` (${counter})`;
        const prefix = baseName.substring(0, 31 - suffix.length);
        candidate = `${prefix}${suffix}`;
        counter++;
      }
      usedNames.add(candidate);
      return candidate;
    },
    safePercent(numerator, denominator) {
      const num = Number(numerator);
      const den = Number(denominator);
      if ((num || num === 0) && den && !isNaN(num) && !isNaN(den)) {
        return (num * 100) / den;
      }
      return "";
    },
    async getProgress() {
      let payload = {
        main_project_id: this.masterData.main_project_id,
        plan_master_id: this.masterData.plan_master_id,
        region_id: this.masterData.region_id,
        fiscal_year: this.masterData.fiscal_year,
      };
      let res;
      res = await this.$apiFire("MonthlyProgress/getProgressRSP", payload);
      for (const x of res?.regions) {
        for (const c of x.form_c_list) {
          c.percent = this.getLastProgress(c.project_section_plan_p1_budget);
          let i = 0;
          for (const y of c.project_section_plan_p1_budget) {
            let correctIndex = this.isInCorrectRange(y, i);
            if (typeof correctIndex !== "boolean") {
              c.plan = y.month_value;
              c.result = y.actual_month_value;
            }
            i++;
          }
        }
        x.yearMonthList = x.yearMonthList.map((ym) => ({
          month_th: format(new Date(ym), "MMM", { locale: th }), // to TH short month
          year_th: (parseInt(ym.toString().split("-")[0]) + 543)
            .toString()
            .slice(2), // last 2 letters of year string
        }));
      }
      console.log("res:", res);
      this.masterData = { ...res, regions: undefined };
      this.regions = res.regions;
      this.regionExpanded = this.regions.map(() => true);
      this.formC = res.form_c.map((item) => ({
        id: item.id,
        name: item.project_section_general_info.project_name_th,
      }));
      this.formD = res.form_d?.map((item) => ({
        id: item.id,
        name: item.form_a.main_project.name,
      }));
      this.formF = res.form_f?.map((item) => ({
        id: item.id,
        name: item.form_a.main_project.name,
      }));
      console.log("C", this.formD);

      this.initializeChart();
    },

    async onSubmit() {
      if (this.$refs.form.validate()) {
        //
        let payload = {
          form_c_id:
            this.form.form_type === "c" ? this.form.form_c_id : undefined,
          form_b_id:
            this.form.form_type === "d" || this.form.form_type === "f"
              ? this.form.form_c_id
              : undefined,
          extend_year: this.form.extend_year,
          extend_month: this.form.extend_month,
          extend_date: this.form.extend_date,
          expiration_date: this.form.expiration_date,
        };
        console.log(payload);

        let res = await this.$apiFire(
          "MonthlyProgress/extendProgressMonth",
          payload
        );
        console.log("sumvvit EX", res);
        if (res) {
          this.$store.commit("General/setModal", {
            title: "เสร็จสิ้น!",
            theme: "success",
            text: "บันทึกข้อมูลสำเร็จ",
            showCancel: false,
            // action: () => this.$router.push({ name: "UserManagement" }),
          });
        }
      }
    },

    resetForm() {
      this.$refs.form.reset();
    },

    totalWF(plans) {
      if (!plans || plans.length === 0) return "-";
      let total = plans
        .map((x) => x.wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    operationPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = x.project_section_plan_p1_budget[index]
          ? parseFloat(x.project_section_plan_p1_budget[index].month_value)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0) / plans.length;
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = x.project_section_plan_p1_budget[index]
          ? parseFloat(
              x.project_section_plan_p1_budget[index].month_value * x.wf
            )
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightActivePlan(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean")
            return this.weightPlan(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    weightActivePlanPercent(plans) {
      let all = [];
      for (let i = 0; i < plans.length; i++) {
        all.push(this.weightPlan(plans, i));
      }

      if (all.length > 0) {
        for (const x of all.reverse()) {
          if (!!x && x !== "-") {
            return x;
          }
        }
      }
      return "-";
    },
    weightActiveResult(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean")
            return this.resultPlan(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    resultPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = !x.project_section_plan_p1_budget[index]
          ?.actual_month_value
          ? 0
          : parseFloat(
              x.project_section_plan_p1_budget[index]?.actual_month_value * x.wf
            );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    budgetPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = !x.project_section_plan_p1_budget[index]?.plan_budget_rate
          ? 0
          : parseFloat(
              x.project_section_plan_p1_budget[index].plan_budget_rate * x.wf
            );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    budgetUse(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = !x.project_section_plan_p1_budget[index]?.use_budget_rate
          ? 0
          : parseFloat(
              x.project_section_plan_p1_budget[index].use_budget_rate * x.wf
            );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    budgetPlanActive(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          // console.log(correctIndex);
          if (typeof correctIndex !== "boolean")
            return this.budgetPlan(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    budgetUseActive(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean")
            return this.budgetUse(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    budgetPlanActivePercent(plans) {
      let all = [];
      for (let i = 0; i < plans.length; i++) {
        all.push(this.budgetPlan(plans, i));
      }

      if (all.length > 0) {
        for (const x of all.reverse()) {
          if (!!x && x !== "-") {
            return x;
          }
        }
      }
      return "-";
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();
      let isCorrectCase =
        (today.getDate() >= 5 && thisMonth === currentMonth) ||
        (today.getDate() <= 4 && thisMonth === currentMonth - 1);

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;
      return isCorrectCase;
    },
    generateYearList() {
      var currentYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth() + 1;
      var yearList = [];

      if (currentMonth >= 10) currentYear++;

      for (var year = currentYear; year >= currentYear - 20; year--) {
        yearList.push(year + 543);
      }

      this.yearList = yearList;
    },

    ToScurve() {
      this.isScurve = !this.isScurve;
    },

    initializeChart() {
      this.generateChartData();
      this.applyFilter();
    },

    generateChartData() {
      this.chartData = this.regions.map((region) => {
        const seriesData = this.masterSeries.map((series) => {
          return {
            name: series.name,
            color: series.color,
            data: region.yearMonthList.map((ym, index) => {
              let value;
              switch (series.name) {
                case "แผนการดำเนินงาน":
                  value = this.operationPlan(region.form_c_list, index);
                  break;
                case "ผลการดำเนินงาน":
                  value = this.resultPlan(region.form_c_list, index);
                  break;
                case "แผนการใช้จ่ายเงิน":
                  value = this.budgetPlan(region.form_c_list, index);
                  break;
                case "การใช้จ่ายจริง":
                  value = this.budgetUseActive(region.form_c_list);
                  break;
                default:
                  value = 0;
              }
              return value !== "-" ? parseFloat(value) : null;
            }),
          };
        });

        return {
          region: region.name,
          categories: region.yearMonthList.map(
            (ym) => `${ym.month_th} ${ym.year_th}`
          ),
          allSeries: seriesData,
          filteredSeries: [...seriesData],
        };
      });
    },

    applyFilter() {
      if (!this.selectedFilter) {
        this.selectedFilter = "all";
      }

      this.chartData.forEach((regionData) => {
        if (this.selectedFilter === "all") {
          regionData.filteredSeries = [...regionData.allSeries];
        } else {
          regionData.filteredSeries = regionData.allSeries.filter(
            (series) => series.name === this.selectedFilter
          );
        }
      });

      // อัพเดต displaySeries สำหรับ legend
      if (this.selectedFilter === "all") {
        this.displaySeries = [...this.masterSeries];
      } else {
        this.displaySeries = this.masterSeries.filter(
          (series) => series.name === this.selectedFilter
        );
      }
    },

    chartOptionByRegion(regionName) {
      const regionData = this.chartData.find(
        (data) => data.region === regionName
      );

      if (!regionData) {
        return this.chartOptions;
      }

      return {
        ...this.chartOptions,
        xAxis: {
          ...this.chartOptions.xAxis,
          categories: regionData.categories,
        },
        series: regionData.filteredSeries,
      };
    },

    // Progress Followed Helper Methods
    getResponsibleStatus(item, dataType) {
      const suffix = dataType === 'actual' ? '_2' : '';
      const taker = item[`progress_month_taker${suffix}`];
      const hours = item[`progress_month_taker_hours${suffix}`];
      return !taker && !hours;
    },

    getResponsibleValue(item, dataType) {
      const suffix = dataType === 'actual' ? '_2' : '';
      const responsibleName = item[`progress_month_taker${suffix}`];
      const hours = item[`progress_month_taker_hours${suffix}`];

      if (!responsibleName) {
        return "ค่างานของ...";
      } else if (!hours) {
        return responsibleName;
      } else {
        return `${responsibleName} (${hours})`;
      }
    },

    getExplanationStatus(item, dataType) {
      const suffix = dataType === 'actual' ? '_2' : '';
      return !item[`progress_month_remark${suffix}`];
    },

    getExplanationValue(item, dataType) {
      const suffix = dataType === 'actual' ? '_2' : '';
      return item[`progress_month_remark${suffix}`] || "รายละเอียด";
    },

    openResponsibleModal(item, dataType) {
      const suffix = dataType === 'actual' ? '_2' : '';
      const hasResponsible = item[`progress_month_taker${suffix}`];
      const hasHours = item[`progress_month_taker_hours${suffix}`];

      // Check what type of modal to open
      let modalType, currentValue;
      if (!hasResponsible) {
        // No responsible person assigned yet
        modalType = "assign";
        currentValue = "";
      } else if (!hasHours) {
        // Has responsible person but no hours
        modalType = "value";
        currentValue = "";
      } else {
        // Has both - editing hours
        modalType = "value";
        currentValue = hasHours;
      }

      this.modalData = {
        show: true,
        type: modalType,
        section: "responsible",
        dataType: dataType,
        item: item,
        value: currentValue,
        responsibleName: hasResponsible || "",
      };

      this.modalInputValue = currentValue;
    },

    openExplanationModal(item, dataType) {
      const suffix = dataType === 'actual' ? '_2' : '';
      const isEmpty = !item[`progress_month_remark${suffix}`];
      const currentValue = item[`progress_month_remark${suffix}`] || "";

      this.modalData = {
        show: true,
        type: isEmpty ? "add" : "edit",
        section: "explanation",
        dataType: dataType,
        item: item,
        value: currentValue,
      };

      this.modalInputValue = currentValue;
    },

    saveModal() {
      if (this.$refs.modalForm.validate()) {
        this.saveModalData(this.modalInputValue);
      }
    },

    async saveModalData(value) {
      const { section, dataType, item, type } = this.modalData;
      const key = `${item.id}_${dataType}`;
      const suffix = dataType === 'actual' ? '_2' : '';

      // Prepare API payload
      let payload = {
        id: item.id,
        type: item.type || 'C', // Default to 'C' if not specified
      };

      // Add appropriate field based on section and type with suffix
      if (section === "responsible") {
        if (type === "assign") {
          payload[`progress_month_taker${suffix}`] = value;
        } else {
          payload[`progress_month_taker_hours${suffix}`] = parseFloat(value).toFixed(2);
        }
      } else if (section === "explanation") {
        payload[`progress_month_remark${suffix}`] = value;
      }

      try {
        // Call API
        let res = await this.$apiFire("MonthlyProgress/updateProgressData", payload);

        if (res) {
          // Update local data in the item with suffix
          if (section === "responsible") {
            if (type === "assign") {
              this.$set(item, `progress_month_taker${suffix}`, value);
            } else {
              this.$set(item, `progress_month_taker_hours${suffix}`, parseFloat(value).toFixed(2));
            }
          } else if (section === "explanation") {
            this.$set(item, `progress_month_remark${suffix}`, value);
          }

          this.closeModal();

          // Success message
          this.$store.commit("General/setModal", {
            title: "เสร็จสิ้น!",
            theme: "success",
            text: "บันทึกข้อมูลสำเร็จ",
            showCancel: false,
          });
        }
      } catch (error) {
        console.error("Error saving progress data:", error);
        this.$store.commit("General/setModal", {
          title: "เกิดข้อผิดพลาด!",
          theme: "error",
          text: "ไม่สามารถบันทึกข้อมูลได้",
          showCancel: false,
        });
      }
    },

    closeModal() {
      this.modalData = {
        show: false,
        type: "",
        section: "",
        dataType: "",
        item: null,
        value: "",
      };
      this.modalInputValue = "";
      this.modalValid = true;
      // Reset modal form validation
      this.$nextTick(() => {
        if (this.$refs.modalForm) {
          this.$refs.modalForm.resetValidation();
        }
      });
    },

    // Modal helper methods
    getModalTitle() {
      const { type, section, responsibleName } = this.modalData;

      if (section === "responsible") {
        if (type === "assign") {
          return "เพิ่มผู้รับผิดชอบ";
        } else {
          return `ค่างานของ ${responsibleName || "..."}`;
        }
      } else if (section === "explanation") {
        return type === "add" ? "เพิ่มคำชี้แจง" : "แก้ไขคำชี้แจง";
      }
      return "จัดการข้อมูล";
    },

    getModalSubtitle() {
      return "ระบุเป็นจำนวนชั่วโมงต่อปี";
    },

    showSubtitle() {
      const { type, section } = this.modalData;
      return section === "responsible" && type === "value";
    },


    expandAll() {
      this.regionExpanded = this.regions.map(() => true);
    },

    collapseAll() {
      this.regionExpanded = this.regions.map(() => false);
    },

    toggleRegion(index) {
      this.$set(this.regionExpanded, index, !this.regionExpanded[index]);
    },

    // Team management methods
    delTeam(index) {
      this.teams.splice(index, 1);
    },

    setTeamField(field, index, value) {
      if (!this.teams[index]) {
        this.$set(this.teams, index, {});
      }
      this.$set(this.teams[index], field, value);
    },
  },
};
</script>

<style scoped lang="scss">
.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.chart-container {
  padding: 10px;
}
.custom-legend {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.custom-legend span {
  display: flex;
  padding: 3px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}
.custom-selectbox-chart {
  width: 100%;
  max-width: 180px;
  border: 1px solid var(--theme-color-seven);
}

.text-underline {
  text-decoration: underline;
}

.cursor-pointer {
  cursor: pointer;
}

/* Modal specific styles removed - no longer needed */

.btn_gradient {
  background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
}

/* Progress Followed specific styles */
.progress-followed-add-field {
  font-size: 11px;
  padding: 3px 2px !important;
  border-radius: 8px;
  background: var(--theme-color-one);
  color: white;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.rotate180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.text-theme-1 {
  color: var(--theme-color-one);
}
</style>
